module.exports = __webpack_public_path__ + "img/7-1-283x400.c60279bc.jpg";